module.exports = __webpack_public_path__ + "static/media/Microsoft_Badge.c41b8e78.svg";